const footer = {
  brand: {
    description:
      "Premium dental care in Sofia, Bulgaria. We combine advanced technology with personalized treatments to give you the perfect smile you deserve.",
  },
  quickLinks: {
    title: "Quick Links",
    home: "Home",
    about: "About Us",
    services: "Services",
    testimonials: "Happy Clients",
    gallery: "Gallery",
    contact: "Contact Us",
  },
  services: {
    title: "Our Services",
    list: {
      implantology: "Implantology",
      endodontics: "Endodontics",
      "oral-surgery": "Oral Surgery",
      periodontology: "Periodontology",
      orthodontics: "Orthodontics",
      prosthetics: "Prosthetics",
    },
  },
  questions: {
    title: "Have Questions?",
    description:
      "We're here to help! Contact us for any questions about our dental services or to schedule an appointment.",
    buttonLabel: "Contact Us",
  },
  bottom: {
    copyright: "© {{year}} Elite Dental Solutions. All rights reserved.",
  },
  legal: {
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
  },
};

export default footer;
